import { Configuration, LogLevel, PublicClientApplication, EventType, AuthenticationResult } from "@azure/msal-browser";

/**
 * MSAL Configuration
 *
 * Replace the placeholder values below with your Azure AD app registration details:
 *   1. Go to https://portal.azure.com → Microsoft Entra ID → App registrations
 *   2. Register a new application (or use an existing one)
 *   3. Copy the "Application (client) ID" → paste as clientId
 *   4. Copy the "Directory (tenant) ID"  → paste into the authority URL
 *   5. Under Authentication → Add platform → "Single-page application"
 *      Set the Redirect URI to match redirectUri below
 */

export const msalConfig: Configuration = {
  auth: {
    clientId: "a0b6e0f0-3629-4e52-ba99-66997c0e9ea2", // Application (client) ID from Azure AD
    authority: "https://login.microsoftonline.com/b841de22-e0c3-40c5-b3fe-c287594b4649", // Directory (tenant) ID
    redirectUri: "/", // Must match the SPA redirect URI in Azure AD
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

/**
 * Scopes requested during login.
 * - "User.Read" grants access to the signed-in user's profile.
 * - "openid", "profile", "email" are standard OIDC scopes.
 */
export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email", "https://ekedp.sharepoint.com/AllSites.Read"],
};

/**
 * Scopes for calling your backend API.
 * Replace with the scope exposed by your API app registration, e.g.:
 *   "api://YOUR_API_CLIENT_ID_HERE/access_as_user"
 */
export const apiTokenRequest = {
  scopes: ["User.Read"],
};

/**
 * Instantiate the PublicClientApplication
 */
export const pca = new PublicClientApplication(msalConfig);

/**
 * Handle successful login events
 */
pca.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    console.log("event", event);
    const payload = event.payload as AuthenticationResult;
    pca.setActiveAccount(payload.account);
    localStorage.setItem("accessToken", payload.accessToken);
  }
});
